import React from 'react';
import { FaTimes } from 'react-icons/fa';

const ModalShell = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  maxWidthClass = 'max-w-xl',
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black bg-opacity-30" onClick={onClose} />
      <div
        className={`bg-white rounded-lg shadow-lg ${maxWidthClass} w-full p-6 relative z-10 max-h-screen overflow-y-auto`}
      >
        <FaTimes
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 cursor-pointer"
          onClick={onClose}
          size={12}
        />
        {title && <h2 className="text-xl font-semibold mb-4">{title}</h2>}
        {children}
        {footer && <div className="flex justify-end mt-4">{footer}</div>}
      </div>
    </div>
  );
};

export default ModalShell;
